/**
 * Safari has a bug where it can't handle many audio elements at once.
 * This is a workaround to make sure we don't create too many audio elements at once, by rendering them one by one.
 */

const IsSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
const BrowserCantHandleManyAudioElementsAtOnce = IsSafari;

const callbackQueue: (() => void)[] = [];

let currentTimeout: number | null = null;
const timeout = () => {
  currentTimeout = null;

  callbackQueue.shift()?.();

  if (callbackQueue.length > 0) {
    currentTimeout = window.setTimeout(timeout, 0);
  }
};

// eslint-disable-next-line import/prefer-default-export
export const requestAudioRendering = (callback: () => void) => {
  if (!BrowserCantHandleManyAudioElementsAtOnce) {
    callback();
    return;
  }

  callbackQueue.push(callback);
  if (currentTimeout === null) {
    currentTimeout = window.setTimeout(timeout, 0);
  }
};
